/**
 * @desc: 进度面板 UI
 */
import Emitter from '../../emitter';
import { firmwareUploader, codeUploader } from './uploader';
let currentType = firmwareUploader.id;
export const UIProgess = {
    id: 'system.ui.progress',
    log(str) {
        //派发上传过程日志
        Emitter.emit('CompilerLog', str);
    },
    error(err) {
        if (currentType == firmwareUploader.id) {
            Emitter.emit('uploadFirmwareFail', err);
        }
        else if (currentType == codeUploader.id) {
            Emitter.emit('UploadCodeProgress', err, null);
        }
        else {
            Emitter.emit('UploadCodeProgress', err, null);
        }
    },
    setProgress(percent) {
        if (percent >= 100)
            return;
        if (currentType == firmwareUploader.id) {
            Emitter.emit('uploadFirmwareProgress', percent);
        }
        else if (currentType == codeUploader.id) {
            Emitter.emit('UploadCodeProgress', null, { type: 'progress', percent });
        }
        else {
            Emitter.emit('UploadCodeProgress', null, { type: 'progress', percent });
        }
    },
    open(type) {
        currentType = type;
        if (currentType == firmwareUploader.id) {
            Emitter.emit('ClickUploadOnlineFirmware');
        }
        else if (currentType == codeUploader.id) {
            Emitter.emit('ClickUploadCode');
        }
        else {
            Emitter.emit('ClickUploadCode');
        }
    },
    close() {
        if (currentType == firmwareUploader.id) {
            Emitter.emit('uploadFirmwareFinished');
        }
        else if (currentType == codeUploader.id) {
            Emitter.emit('UploadCodeProgress', null, { type: 'finish', percent: 100 });
        }
        else {
            Emitter.emit('UploadCodeProgress', null, { type: 'finish', percent: 100 });
        }
    }
};
